import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AccountRoleService } from 'auth/account-role.service';
import { UserRole } from 'generated/graphql';

/**
 * If the passed value is true display the view
 * If the pass value is false display view if admin
 */
// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[appIfOrAdmin]' })
export class IfOrAdminDirective {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private accountRoleService: AccountRoleService,
    private viewContainer: ViewContainerRef) { }

  @Input() set appIfOrAdmin(valueToCheck: boolean) {
    if (valueToCheck) {
      this._createViewIfNeeded();
      return;
    }

    const isAdmin = this.accountRoleService.userHasMinRole(UserRole.Administrator);
    if (isAdmin) {
      this._createViewIfNeeded();
      return;
    }

    this.destroyViewIfNeeded();
  }

  private _createViewIfNeeded() {
    if (this.hasView) { return; }
    this.viewContainer.createEmbeddedView(this.templateRef);
    this.hasView = true;
  }

  private destroyViewIfNeeded() {
    if (!this.hasView) { return; }
    this.viewContainer.clear();
    this.hasView = false;
  }
}
